<template>
  <div v-if="details.length">
        <VDataTable
            :headers="headers"
            :items="details"
            :must-sort="true"
            hide-actions
            no-data-text="Não há dados a serem exibidos"
            item-key
            class="my-4"
        >
            <template slot="items" slot-scope="props">
            <td>{{ dateFormat(props.item.updatedAt) }}</td>
            <td>{{ timeProcess(props.item)  || "0.00" }}</td>
            <td>{{ props.item.payload.name || "-"}}</td>
            <td>{{ props.item.payload.cnpj || "-"}}</td>
            <td>{{ props.item.payload.id_pdv_db || "-"}}</td>
            <td>{{ getStatus(props.item.status) }}</td>
            <td>
                <Payload :payload="props.item.payload" title="Payload unitário"/>
            </td>
            <td>
                <Reason :reason="props.item.reason" />
            </td>
            </template>
        </VDataTable>
    </div>
</template>

<script>
import { formatBRDateTime } from "utils/date";
export default {
    props: {
        details: {
            type: Array,
            default: () => []
        }
    },
    components: {
        Reason: () => import("../modal/Reason"),
        Payload: () => import("../modal/Payload")
    },
    data() {
        return {
            currentPage: "",
            modal: null,
            headers: [
                { text: "Data processamento", value: "updatedAt", sortable: false},
                { text: "Tempo de processamento", value: "duration", sortable: false},
                { text: "Nome do PDV", value: "pdv_name", sortable: false},
                { text: "CNPJ", value: "cnpj", sortable: false},
                { text: "ID PDV DB", value: "id_pdv_db", sortable: false},
                { text: "Status", value: "status", sortable: false},
                { text: "Payload", value: "payload", sortable: false},
                { text: "Motivo", value: "reason", sortable: false},
            ],
        };
    },
    methods: {
        getStatus(status) {
            switch (status) {
                case 'IN_PROCESS': return 'Em processamento';
                case 'PROCESSED': return 'Processado';
                case 'ERROR_PROCESS': return 'Erro ao processar';
                default: return '-';
            }
        },
        dateFormat(date) {
            return formatBRDateTime(date);
        },
        timeProcess(item) {
            return ((new Date(item.updatedAt) - new Date(item.createdAt))/60000).toFixed(2);
        }
    }
}
</script>
